// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__1VC87","lang":"Header_lang__19ZlG","auth":"Header_auth__22ubL","return":"Header_return__D4VE8"};